import { t } from 'i18next';
import { Operation } from '../../components/FilterPanel/enum/Operation';

const OTHER_VALUE = 'other';

export const KEY_LENGTHS = [56, 64, 128, 168, 192, 256, 384, 512, 1024, 2048, 3072, 4096];

export const KEY_LENGTH_OPTIONS = () => [
  ...KEY_LENGTHS.map((value) => value.toString()).map((value) => ({ value, label: value })),
  { value: OTHER_VALUE, label: t('other') },
];

export const KEY_LENGTH_OPTION_VALIDATOR = (op: Operation) => (value: string) => {
  if (op !== Operation.EQ && value === OTHER_VALUE) {
    return t('keyLengthInvalidOtherFilter');
  }
  return true;
};
